import { useState } from "react";
import { MapPin, Loader2, CloudSun } from "lucide-react";

// Invito al cliente a indicare la sua località (meteo e cielo reali di casa sua)
export function LocalitaInvite({ src, onSaved, azienda }) {
  const [v, setV] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const go = async () => {
    setBusy(true); setErr("");
    try { await src.localita({ indirizzo: v }); onSaved(); } catch (e) { setErr(e.response?.data?.detail || "Salvataggio non riuscito"); }
    setBusy(false);
  };
  return (
    <div className="rounded-3xl bg-gradient-to-br from-sky-500 to-cyan-400 p-4 text-white shadow-lg" data-testid="cliente-localita">
      <div className="flex items-start gap-3">
        <span className="rounded-2xl bg-white/20 p-2"><CloudSun className="h-6 w-6" /></span>
        <div className="min-w-0">
          <b className="block text-base">Dove si trova il tuo impianto?</b>
          <p className="text-xs text-white/90">Aggiungi la tua località: vedrai il meteo e il cielo reali {azienda ? "della tua azienda" : "di casa tua"} e Vesta potrà spiegarti meglio la produzione.</p>
        </div>
      </div>
      <div className="mt-3 flex gap-2">
        <div className="relative min-w-0 flex-1">
          <MapPin className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-sky-500" />
          <input value={v} onChange={(e) => setV(e.target.value)} onKeyDown={(e) => e.key === "Enter" && v.trim().length > 2 && go()} placeholder="Via e comune"
            className="h-11 w-full rounded-2xl bg-white pl-9 pr-3 text-sm text-slate-800 outline-none" data-testid="cliente-localita-input" />
        </div>
        <button type="button" onClick={go} disabled={busy || v.trim().length < 3} data-testid="cliente-localita-salva"
          className="shrink-0 rounded-2xl bg-slate-900 px-4 text-sm font-bold text-white transition-opacity disabled:opacity-50">{busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Salva"}</button>
      </div>
      {err && <p className="mt-2 text-xs font-semibold text-white" data-testid="cliente-localita-errore">{err}</p>}
    </div>
  );
}
